import { getUserDetails } from "../platform-core";

export const gtag: Gtag.Gtag = function () {
  // @ts-ignore
  dataLayer.push(arguments);
};

export function initialize() {
  //@ts-ignore
  // noinspection JSUnresolvedReference
  const measurementId = window.env.GA_MEASUREMENT_ID;
  //@ts-ignore
  window.dataLayer = window.dataLayer || [];
  const scriptId = "ga-gtag";
  const { head } = document;
  const script = document.createElement("script");
  script.id = scriptId;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  head.insertBefore(script, head.firstChild);

  // initialize
  gtag("js", new Date());
  gtag("config", measurementId, {
    user_id: getUserDetails().uid,
  });
}
